import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CIAMLogin = _resolveComponent("CIAMLogin");
  return $data.showForm ? (_openBlock(), _createBlock(_Teleport, {
    key: 0,
    to: $options.selectorCIAMLogin
  }, [_createVNode(_component_CIAMLogin)], 8, ["to"])) : _createCommentVNode("", true);
}